import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import './login.css';
import * as config from '../config';
import logo from '../Image/logo.png'

const Login = () => {
  let [loginInfo, setLoginInfo] = useState({
    mobileNumber: '',
    supplierName: '',
    supplierNotFound: '',
    password: '',
    serverPassword: "",
    login_id: "",
    error_message: "",
  })

  const navigate = useNavigate();
  localStorage.clear();

  let login_id = localStorage.getItem("login_id");

  useEffect(() => {
    if (login_id) {
      navigate("/report");
    }
    
    document.title = "Bill Tracking";
  }, [login_id])

  const createConfig = () => {
    return {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "access-control-expose-headers": "*",
        "access-control-allow-methods": "GET, HEAD, POST, PUT, PATCH, DELETE, OPTIONS"
      }
    };
  }

  const handleLogin = () => {
    if (loginInfo.mobileNumber && loginInfo.supplierName) {
      localStorage.setItem("login_id", loginInfo.login_id);
      localStorage.setItem("serverPassword", loginInfo.serverPassword);
      if (loginInfo.serverPassword === null) {
        navigate("/signUp");
      } else if (loginInfo.serverPassword == loginInfo.password) {
        console.log("Password:", loginInfo.password);
        navigate("/report");
      } else {
        console.log("Invalid login");
        console.log("Password Error");
        setLoginInfo({
          ...loginInfo,
          error_message: "Invalid login"
        })
      }
    } else {

      console.log("Invalid login");
      console.log("Password Error");
      setLoginInfo({
        ...loginInfo,
        error_message: "Invalid login"
      })
    }
  }


  return (
    <div className="background">
      <div className="container">
        <img src={logo} alt="Logo" className="LogoDesign" />
        <h1>Bill Tracking</h1>
        <div className="input">
          <p style={{ color: "red" }}> {loginInfo.error_message}</p>
          <input
            type="number"
            value={loginInfo.mobileNumber}
            placeholder="Enter Your Mobile/TIN Number"
            onChange={(e) => {
              setLoginInfo({
                ...loginInfo,
                mobileNumber: e.target.value
              })
            }}
            onBlur={(e) => {
              if (e.target.value == '') {
                return false;
              }

              axios.get(`${config.DevelopmentUri}/api/Login/GetAllSuppliersPassword/${e.target.value}`, createConfig()).then(res => {
                console.log(res.data.password)
                if (res.status == 204) {
                  setLoginInfo({
                    ...loginInfo,
                    supplierNotFound: "Supplier Not Found",
                    supplierName: "",

                  })
                } else {

                  let isPassword = '';
                  if (!res.data.password) {
                    isPassword = res.data.supplierMobile
                  }
                  setLoginInfo({
                    ...loginInfo,
                    supplierName: res.data.supplierName,
                    password: isPassword,
                    supplierNotFound: "",
                    serverPassword: res.data.password,
                    login_id: res.data.id,
                  })
                }

              });
            }}
            required
          />
        </div>
        <div className="input">
          <input
            type="test"
            placeholder="Comapany Name"
            value={loginInfo.supplierName}
            readOnly
          />
          <p style={{ color: "red" }}>{loginInfo.supplierNotFound}</p>
        </div>
        <div className="input">
          <input
            type="password"
            value={loginInfo.password}
            placeholder="Password"
            onChange={(e) => {
              setLoginInfo({
                ...loginInfo,
                password: e.target.value
              })
            }}
            required
          />
        </div>
        <button type='button' onClick={handleLogin}>
          Login
        </button>
      </div>
    </div>
  );
};

export default Login;
